import React from 'react';
import useStyles from './Styles';
import { Box, Typography, Grid} from '@material-ui/core';
import sidebarCollapse from '../../../../assets/sidebar-hide.png';

const ChartDrawer = (props) => {
    const classes = useStyles();
    const { charts, onClose, setChart } = props;
    return (
        <Box className={classes.chartDrawer}>
            <Grid container item>
                <Grid item xs={12} className={classes.chartItem} 
                    style={{ 
                        height: 90, 
                        background: 'transparent', 
                        marginBottom: 0, 
                        flexDirection: 'row', 
                        alignItems: 'center' 
                    }}
                >
                    <Typography variant='h4' component='div' className={classes.chooseText}>Choose Chart</Typography>
                    <img
                        src={sidebarCollapse}
                        className={classes.chartToggleIcon}
                        style={{ paddingRight: 32 }}
                        onClick={onClose}
                        alt="toggle-icon.png"
                    />
                </Grid>
                {
                    charts.map((chart,index) => (
                        <Grid item xs={12} onClick={() => {setChart(index); onClose();}} className={classes.chartItem}>
                            <Typography variant='h6' component='div' className={classes.chartItemTitle}>{chart.name}</Typography>
                            {/* <Typography variant='body2' component='p' className={ classes.chartItemDesc }>{chart.desc}</Typography> */}
                        </Grid>
                            
                    ))
                }
                
            </Grid>
        </Box>
    );
};

export default ChartDrawer;